import React from 'react';
import { ChatPanel } from '../components/ChatPanel';
import { AtAGlance } from '../components/AtAGlance';
import type { Brand, ChatMessage, Page } from '../types/portal';
interface HomeProps {
  brand: Brand;
  messages: ChatMessage[];
  typing: boolean;
  draft: string;
  onDraftChange: (value: string) => void;
  onSend: (text: string) => void;
  onOpenLoan: (id: string) => void;
  onNavigate: (page: Page) => void;
}
export function Home({
  onOpenLoan,
  onNavigate,
  ...chat
}: HomeProps) {
  return <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-start gap-8 xl:grid-cols-[minmax(0,1fr)_380px]" data-id="element-156" data-mp="24gim4gan7gpe">
      <ChatPanel {...chat} data-id="element-157" data-mp="29f27oflbqqh8" />
      <AtAGlance onOpenLoan={onOpenLoan} onNavigate={onNavigate} data-id="element-158" data-mp="29etu0lhdnh4z" />
    </div>;
}